<template lang="pug">
  v-card()
    v-card-title.primary.white--text.font-weight-bold Edit the details
    .mx-5.mt-8()
      v-text-field(label='Name' v-model='name' :hide-details='false' :rules='[rules.required]' required)
      v-text-field(label='Description' v-model='description' :hide-details='false' :rules='[rules.required]' required)
      show-advanced(@toggle="showAdvanced=!showAdvanced" :showAdvanced="showAdvanced")
      div(v-show="showAdvanced")
        div(v-if="geometry.type =='Point'")
          v-text-field(label='Radius' v-model='radius' :hide-details='false' )
        .caption.grey--text.font-italic() No selection defaults to all vehicles
        vehicles-auto-complete.mt-0(v-model="vehicles_id" :multiple="true" label="Select Vehicle")
        .caption.grey--text.font-italic() No selection defaults to all contacts
        contacts-auto-complete(v-model="contacts_id" :multiple="true" label="Select Contacts")
        v-row()
          v-col(cols="5")
            div.pl-2.grey.lighten-3.actionContainer()
              div.subtitle-2.primary--text() Actions
              v-row()
                v-col(cols="6")
                  v-checkbox.mt-0(v-model="entry" label="Entry" hide-details)
                v-col(cols="6")
                  v-checkbox.mt-0(v-model="exit" label="Exit" hide-details)
          v-col(cols="7")
            div.pl-2.grey.lighten-3.actionContainer()
              div.subtitle-2.primary--text() Alert Actions
              v-row()
                v-col(cols="6")
                  v-checkbox.mt-0(v-model="email" label="Send E-mail" hide-details)
                v-col(cols="6")
                  v-checkbox.mt-0(v-model="sms" label="Send SMS" hide-details)
        v-divider.mt-8.mb-4()
        v-row()
          v-checkbox.mt-0.mx-3(v-model="hiden_in_other_maps" label="Hide Geofence in Other Maps" hint="Useful for Large Areas e.g Cities, Countrys etc." :persistent-hint="true")
        v-divider.mt-8.mb-4()


    v-card-actions.mt-1()
      v-spacer()
      v-btn.mr-2.mb-4(outlined color="gray"  @click="$emit('cancel')") cancel
      v-btn.mr-2.mb-4(color="primary" @click="$emit('save')") save

</template>

<script>
import {createHelpers} from "vuex-map-fields";
import VehiclesAutoComplete from "@/modules/global/components/forms/VehiclesAutoComplete";
import ContactsAutoComplete from "@/modules/global/components/forms/ContactsAutoComplete";
import ShowAdvanced from "@/modules/global/components/forms/ShowAdvanced";

const {mapFields} = createHelpers({
  getterType: "geofence/getGeofence",
  mutationType: "geofence/updateGeofence"
});
export default {
  components: {
    VehiclesAutoComplete,
    ContactsAutoComplete,
    ShowAdvanced
  },
  data: () => ({
    showAdvanced: false,
    showDialog: true,
    valid: true,
    error: false,
    errors: [],
    rules: {
      required: value => !!value || "Required.",
    },
  }),

  mounted() {
    console.log(this.$store.getters["geofence/getCurrentGeofence"])
  },

  computed: {
    ...mapFields([
      "id",
      "name",
      "description",
      "radius",
      "geometry",
      "place",
      "place_id",
      "contacts_id",
      "vehicles_id",
      "entry",
      "exit",
      "email",
      "sms",
      "visibility",
        "hiden_in_other_maps"
    ])
  },

  methods: {}

}
</script>

<style lang="stylus" scoped>
.geoDetailContent {
  margin-top 0px;
  padding-top 0px;
}

.actionContainer {
  border-radius 10px;
}
</style>